import React, { useEffect } from 'react'
import gsap from 'gsap'
import styled from 'styled-components'
import media from 'styles/media'

import partnersImage from 'svg/partners.svg'

import { HeadlineM } from 'components/Text'

import { ReactComponent as IllustrationSVG } from 'svg/contactIllustration.svg'
type Props = {
  noIllustration?: boolean
}

const Partners: React.FC<Props> = ({ noIllustration }) => {
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: '.partners__wrapper',
      repeat: -1,
    })
    tl.to('.partners__image', {
      x: '-100%',
      ease: 'none',
      duration: 25,
    }).to('.partners__image', { x: 0, duration: 0 })
  }, [])
  return (
    <Wrapper className="partners__wrapper">
      {!noIllustration && <Illustration />}
      <Title>
        Fully integrated <br /> support for
      </Title>
      <Images>
        <PartnersImageWrapper className="partners__image">
          <PartnersImage
            src={partnersImage}
            alt="Partners"
            width="2255"
            height="57"
          />
        </PartnersImageWrapper>
        <PartnersImageWrapper className="partners__image">
          <PartnersImage
            src={partnersImage}
            alt="Partners"
            width="2255"
            height="57"
          />
        </PartnersImageWrapper>
      </Images>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 624px;
  padding-top: 200px;
  width: 100%;
  position: relative;
  ${media.fullWidth} {
    height: 37.1vw;
    padding-top: 11.9vw;
  }
  ${media.tabletLandscape} {
    height: 450px;
    padding-top: 96px;
  }
  ${media.mobile} {
    height: 450px;
    padding-top: 96px;
  }
`
const Title = styled(HeadlineM)`
  margin-left: 96px;
  ${media.fullWidth} {
    margin-left: 5.7vw;
  }
  ${media.tabletLandscape} {
    margin-left: 72px;
  }
  ${media.tablet} {
    margin-left: 48px;
  }
  ${media.mobile} {
    margin-left: 12px;
    line-height: 100%;
    font-size: 36px;
  }
`
const Images = styled.div`
  display: flex;
  overflow: hidden;
`
const PartnersImageWrapper = styled.div`
  //width: 2050px;
  flex-shrink: 0;
`
const PartnersImage = styled.img`
  width: 2255px;
  margin-top: 64px;
  flex-shrink: 0;
  padding-left: 0;
  ${media.fullWidth} {
    // width: 132.4vw;
    // height: 3.8vw;
    // padding-left: 5.7vw;
  }
`

const Illustration = styled(IllustrationSVG)`
  width: 282px;
  position: absolute;
  top: -98px;
  left: 24.6vw;
  ${media.fullWidth} {
    width: 16.8vw;
    top: -5.8vw;
    right: auto;
  }
  ${media.tablet} {
    left: -24px;
    top: -192px;
  }
  ${media.mobile} {
  }
`
export default Partners
